import type { Element } from '@/components/canvas/document/publicTypes';

/** 右键菜单操作对象：多选时保留全部；点在已选编组内的子元素上时不坍缩为单选。 */
export function resolveContextMenuActionIds(
  selectedElementIds: string[],
  targetElement: Element | null,
  pageElements: Element[],
): string[] {
  if (selectedElementIds.length > 1) {
    return selectedElementIds;
  }
  if (!targetElement) return [];
  if (selectedElementIds.includes(targetElement.id)) {
    return selectedElementIds;
  }
  let parentId = targetElement.layout.parentId;
  while (parentId) {
    if (selectedElementIds.includes(parentId)) {
      return selectedElementIds;
    }
    parentId = pageElements.find((e) => e.id === parentId)?.layout.parentId;
  }
  return [targetElement.id];
}

/** 可参与编组的顶层 id（父级不在当前操作集合内）。 */
export function resolveGroupableRootIds(
  pageElements: Element[],
  actionIds: string[],
): string[] {
  const actionSet = new Set(actionIds);
  return actionIds.filter((id) => {
    const el = pageElements.find((e) => e.id === id);
    if (!el) return false;
    return !el.layout.parentId || !actionSet.has(el.layout.parentId);
  });
}

export function isHitInCurrentSelection(
  elementId: string,
  parentId: string | undefined,
  selectedIds: Set<string>,
  pageElements: Element[],
): boolean {
  if (selectedIds.has(elementId)) return true;
  let pid = parentId;
  while (pid) {
    if (selectedIds.has(pid)) return true;
    pid = pageElements.find((e) => e.id === pid)?.layout.parentId;
  }
  return false;
}
